<template>
    <div class="edit">
        <Form ref="virtualOfficeTemplateForm" :label-width="120" :model="virtualOfficeTemplateSettings" :rules="virtualOfficeTemplateRules">
            <FormItem v-if="virtualOfficeTemplateSettings.id" label="id：" prop="id">
                {{ virtualOfficeTemplateSettings.id }}
            </FormItem>
            <FormItem :label="$t('virtualOfficeManagement.virtualOfficeTemplate.Detail.virtualOfficeTemplateSettings.templateName')" prop="templateName">
                <Input v-model="virtualOfficeTemplateSettings.templateName" style="width: 200px"/>
            </FormItem>
            <FormItem :label="$t('virtualOfficeManagement.virtualOfficeTemplate.Detail.virtualOfficeTemplateSettings.templateDimension')" prop="templateDimension">
                <Select v-model="virtualOfficeTemplateSettings.templateDimension" style="width: 200px">
                    <Option :value="'16:9'">16:9</Option>
                    <Option :value="'4:3'">4:3</Option>
                </Select>
            </FormItem>
            <FormItem
                :label="$t('virtualOfficeManagement.virtualOfficeTemplate.Detail.virtualOfficeTemplateSettings.backgroundPath.title')"
                prop="backgroundPath"
                key="backgroundPath"
            >
                <Uploader
                    ref="uploader"
                    :action="virtualOfficeTemplateSettings.uploadServerUrl"
                    @save="save"
                    @done="onUploadDone"
                    class="uploader"
                    :id="id"
                    :userId="userId"
                    :imageUrl="virtualOfficeTemplateSettings.uploadServerUrl + virtualOfficeTemplateSettings.backgroundPath"
                    :fixedNumber="[16, 9]"
                    :type="7"
                    :full="true"
                    @on-select="onUploadSelect"
                >
                    <Button type="primary" icon="ios-cloud-upload-outline">{{ $t('Button.uploadImg') }}</Button>
                </Uploader>
                <small>{{ $t('virtualOfficeManagement.virtualOfficeTemplate.Detail.virtualOfficeTemplateSettings.backgroundPath.prompt') }}</small>
            </FormItem>
            <FormItem>
                <Button type="primary" :loading="save_loading" @click="debounce(()=>{clickSaveBtn('virtualOfficeTemplateForm')})">{{ $t('Button.save') }}</Button>
                <Button style="margin-left: 8px" @click="$router.go(-1)">{{ $t('Button.back') }}</Button>
            </FormItem>
        </Form>
        <Spin v-show="loading" fix class="spin">
            <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";
    import api from "@/api/Api";
    import extend from "extend";
    import Uploader from "@/components/upload/upload-pic";
    export default {
        props: ['id'],
        components: {
            Uploader
        },
        data() {
            return {
                loading: false,
                save_loading: false,
                categoryList: [],
                globalCategoryList: [],
                virtualOfficeTemplateSettings: {
                    id: 0,
                    templateName: '',
                    templateDimension: '',
                    backgroundPath: ''
                },
                virtualOfficeTemplateRules: {
                    templateName: [
                        { required: true, message: this.$t('virtualOfficeManagement.virtualOfficeTemplate.Detail.virtualOfficeTemplateRules.templateName'), trigger: 'blur' }
                    ],
                    backgroundPath: [
                        {
                            type: "string",
                            required: true,
                            validator: (rule, value, callback) => {
                                // 验证是否选择了图片
                                if (this.virtualOfficeTemplateSettings.id != 0) {
                                    callback();
                                } else if (this.$refs.uploader.file.id) {
                                    callback();
                                } else {
                                    callback(this.$t('Message.selectImg'));
                                }
                            }
                        }
                    ]
                },
            }
        },
        computed: {
            ...mapState({
                uploadPath: state => state.uploader.uploadPath,
                uploaderLoading: state =>
                    state.uploader.UploadServer.loadingStatus == "loading",
                uploaderReady: state =>
                    state.uploader.UploadServer.loadingStatus == "done",
                uploaderResult: state => state.uploader.newMaterialStatus,
                userId: state => state.user.id
            })
        },
        watch: {
            uploaderResult(val) {
                let item = val[val.length - 1];
                if (!item.status) {
                    this.pagination.page == 1 && this.refresh();
                } else {
                    ;
                }
            }
        },
        methods: {
            onUploadSelect(file, url) {
                this.virtualOfficeTemplateSettings.backgroundPath = url;
                console.log(this.virtualOfficeTemplateSettings.backgroundPath)
            },
            onUploadDone(){
                this.loading = false;
                this.save_loading = false;
            },
            async clickSaveBtn(name){

                if(!this.hasPermission('saveTemplate')){
                    this.$Notice.error({ title: this.$t('Message.permission.error') });
                    return;
                }

                let valid = await this.$refs[name].validate();
                if (!valid){
                    this.$Notice.error({ title: this.$t('Message.save.error') });
                    return;
                }

                try {
                    if(this.$refs.uploader.file.id) {
                        this.loading = true;
                        this.save_loading = true;
                        this.$refs.uploader.upload();
                        return;
                    }
                    await this.save();
                } catch (e) {
                    console.log(e);
                    this.$Notice.error({ title: this.$t('Message.save.success') });
                }
            },
            async save(){
                this.loading = true;
                this.save_loading = true;
                try{
                    this.virtualOfficeTemplateSettings.uploadPath = this.uploadPath || this.virtualOfficeTemplateSettings.backgroundPath;
                    let ret = await api.call("virtualOffice/templateSave",  {
                        id: this.virtualOfficeTemplateSettings.id,
                        templateName: this.virtualOfficeTemplateSettings.templateName,
                        templateDimension: this.virtualOfficeTemplateSettings.templateDimension,
                        uploadPath: this.virtualOfficeTemplateSettings.uploadPath,
                        // backgroundPath: this.virtualOfficeTemplateSettings.backgroundPath,
                        backgroundServerId: this.virtualOfficeTemplateSettings.softwareId
                    });

                    this.$store.commit('uploader/setUploadPath', "");

                    this.$Notice.success({ title: this.$t('Message.save.success') });

                    this.$router.go(-1);
                }
                catch (e) {
                    this.$Notice.error({ title: this.$t('Message.save.error') });
                }
                this.save_loading = false;
                this.loading = false;
            },
            async refresh() {
                this.loading = true;
                try {
                    let ret = await api.call("virtualOffice/templateInfo", {
                        id: this.id
                    });
                    this.$store.commit("uploader/setUploadPath", "");

                    if(this.id == 0){
                        this.virtualOfficeTemplateSettings = extend({}, true, this.virtualOfficeTemplateSettings, ret.uploadJson);
                    }else {
                        this.virtualOfficeTemplateSettings = extend({}, true, ret.data, ret.uploadJson);
                    }
                } catch (e) {
                    console.log(e)
                }
                this.loading = false;
            }
        },
        mounted() {
            this.refresh();
        },
        created() {},
        beforeDestroy() {}
    }
</script>

<style scoped>
    .edit{
        position: relative;
        border-radius: 5px;
        background: white;
        padding: 10px 20px;
    }
</style>